module.exports = __webpack_public_path__ + "img/ao.078e1a24.svg";